import axios from 'axios';
import {
    DELETE_LOADING_STATE,
    GET_LOADING_STATE,
    GET_LOADING_STATES,
    POST_LOADING_STATE,
    UPDATE_LOADING_STATE
} from '../routes';

export default {
    async all(options = {}) {
        return await axios.get(GET_LOADING_STATES, options);
    },
    async get(loading_state, options = {}) {
        return await axios.get(GET_LOADING_STATE(loading_state), options);
    },
    async create(data, options = {}) {
        return await axios.post(POST_LOADING_STATE, data, options);
    },
    async update(loading_state, options = {}) {
        return await axios.patch(UPDATE_LOADING_STATE(loading_state), options);
    },
    async delete(loading_state, options = {}) {
        return await axios.delete(DELETE_LOADING_STATE(loading_state), options);
    },
};
